import type { BranchDetail } from "@/types";

export const branches: BranchDetail[] = [
  {
    id: "b1",
    name: "فرع العليا",
    city: "الرياض",
    address: "طريق العليا العام، حي العليا",
    phone: "0112345678",
    manager: "سعد الحربي",
    managerId: "emp1",
    isOpen: true,
    isActive: true,
    hours: "١١:٠٠ ص — ١٢:٠٠ ص",
    staffCount: 6,
    ordersToday: 52,
    salesToday: 3820.5,
    carPickup: true,
    localPickup: true,
    deliveryEnabled: true,
    deliveryFee: 15,
  },
  {
    id: "b2",
    name: "فرع النخيل",
    city: "الرياض",
    address: "طريق الملك عبدالله، حي النخيل",
    phone: "0112345679",
    manager: "ريم العتيبي",
    managerId: "emp4",
    isOpen: true,
    isActive: true,
    hours: "١١:٠٠ ص — ١:٠٠ ص",
    staffCount: 5,
    ordersToday: 38,
    salesToday: 2740,
    carPickup: true,
    localPickup: false,
    deliveryEnabled: false,
    deliveryFee: 0,
  },
  {
    id: "b3",
    name: "فرع الملقا",
    city: "الرياض",
    address: "شارع أنس بن مالك، حي الملقا",
    phone: "0112345680",
    manager: "سارة العمري",
    managerId: "emp8",
    isOpen: false,
    isActive: true,
    hours: "١٢:٠٠ م — ١٢:٠٠ ص",
    staffCount: 4,
    ordersToday: 21,
    salesToday: 1180,
    carPickup: false,
    localPickup: true,
    deliveryEnabled: false,
    deliveryFee: 0,
  },
  {
    id: "b4",
    name: "فرع الحمراء",
    city: "الرياض",
    address: "طريق الملك فهد، حي الحمراء",
    phone: "0112345681",
    manager: "",
    managerId: "",
    isOpen: false,
    isActive: false,
    hours: "١١:٠٠ ص — ١٢:٠٠ ص",
    staffCount: 0,
    ordersToday: 0,
    salesToday: 0,
    carPickup: true,
    localPickup: true,
    deliveryEnabled: false,
    deliveryFee: 0,
  },
];